module.exports = __webpack_public_path__ + "static/WT_Information_Card-Actionable-42e2a21a0e7c361969495163729be7f0.png";